import { AlertTriangle, ChevronDown, ChevronUp } from "lucide-react";
import { Alert, AlertDescription } from "../../../../../components/ui/alert";
import { useState } from "react";
import { Button } from "../../../../../components/ui/button";

interface LowConfidenceWarningProps {
  confidence: number;
  reasoning: string | null;
}

export function LowConfidenceWarning({
  confidence,
  reasoning,
}: LowConfidenceWarningProps) {
  const [showReasoning, setShowReasoning] = useState(false);
  const confidencePercent = Math.round(confidence * 100);

  return (
    <Alert className="bg-amber-50 border-amber-200">
      <AlertTriangle className="h-4 w-4 text-amber-600" />
      <AlertDescription className="text-amber-800">
        <div className="flex flex-col gap-2">
          <div className="flex items-center justify-between">
            <span>
              Auto-matching confidence is low ({confidencePercent}%). Please
              review all mappings carefully.
            </span>
            {reasoning && (
              <Button
                variant="ghost"
                size="sm"
                className="h-6 px-2 text-amber-700 hover:text-amber-900 hover:bg-amber-100"
                onClick={() => setShowReasoning(!showReasoning)}
              >
                {showReasoning ? (
                  <>
                    Hide details <ChevronUp className="ml-1 h-3 w-3" />
                  </>
                ) : (
                  <>
                    Show details <ChevronDown className="ml-1 h-3 w-3" />
                  </>
                )}
              </Button>
            )}
          </div>
          {showReasoning && reasoning && (
            <p className="text-sm text-amber-700 bg-amber-100/50 p-2 rounded">
              {reasoning}
            </p>
          )}
        </div>
      </AlertDescription>
    </Alert>
  );
}
